"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWeekTypography = exports.StyledMonthTypography = exports.StyledDateTypography = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Typography = _interopRequireDefault(require("../../../Typography/index.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const StyledMonthTypography = exports.StyledMonthTypography = (0, _styledComponents.default)(_Typography.default)`
	${({
  hoverColor,
  theme,
  color,
  hoverBgColor,
  fontFamily,
  fontSize,
  fontWeight,
  fontStyle,
  textTransformation = 'none',
  textDecoration = 'none'
}) => {
  return `
                cursor: pointer;
                font-size:${fontSize || theme.typography.fontSizeH5};
                font-weight: ${fontWeight || theme.typography.fontWeightBold};
                font-family: ${fontFamily || theme.typography.fontFamily};
                font-style:${fontStyle || 'normal'};
                color: ${color};
                text-transform:${textTransformation};
                text-decoration:${textDecoration == 'strike_of' ? 'line-through' : textDecoration == 'underline_overline' ? 'underline overline' : textDecoration};
                &:hover{
                    color: ${hoverColor};
                    background-color: ${hoverBgColor};
                }
            `;
}}
`;
const StyledWeekTypography = exports.StyledWeekTypography = (0, _styledComponents.default)(_Typography.default)`
${({
  color,
  hoverTextColor,
  hoverBgColor,
  fontFamily,
  fontSize = '16px',
  fontWeight = '600',
  fontStyle,
  textTransformation = 'none',
  textDecoration = 'none',
  lineHeight
}) => (0, _styledComponents.css)`
    font-size:${fontSize} !important;
    font-weight: ${fontWeight}  !important;
    font-family: ${fontFamily} !important;
    font-style:${fontStyle || 'normal'} !important;
    color: ${color};
    text-transform:${textTransformation};
    line-height:${lineHeight}px !important;
    text-decoration:${textDecoration == 'strike_of' ? 'line-through' : textDecoration == 'underline_overline' ? 'underline overline' : textDecoration};
    &:hover{
        color: ${hoverTextColor};
        background-color: ${hoverBgColor};
    }
`}
`;
const StyledDateTypography = exports.StyledDateTypography = (0, _styledComponents.default)(_Typography.default)`
${({
  color,
  hoverTextColor,
  hoverBgColor,
  fontFamily,
  fontSize = '14px',
  fontWeight = '700',
  fontStyle,
  textTransformation = 'none',
  textDecoration = 'none',
  lineHeight = 16
}) => (0, _styledComponents.css)`
    font-size:${fontSize} !important;
    font-weight: ${fontWeight}  !important;
    font-family: ${fontFamily} !important;
    font-style:${fontStyle || 'normal'} !important;
    color: ${color};
    text-transform:${textTransformation};
    line-height:${lineHeight}px !important;
    text-decoration:${textDecoration == 'strike_of' ? 'line-through' : textDecoration == 'underline_overline' ? 'underline overline' : textDecoration};
    &:hover{
        color: ${hoverTextColor};
        background-color: ${hoverBgColor};
    }
`}
`;